import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mfs_aff_token";
const INFO_KEY = "mfs_aff_info";

export const getAffToken = () => localStorage.getItem(TOKEN_KEY);
export const setAffToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const setAffInfo = (info) => localStorage.setItem(INFO_KEY, JSON.stringify(info));
export const getAffInfo = () => {
  try {
    return JSON.parse(localStorage.getItem(INFO_KEY));
  } catch {
    return null;
  }
};
export const clearAffSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(INFO_KEY);
};

export const affApi = axios.create({ baseURL: API });
affApi.interceptors.request.use((config) => {
  const t = getAffToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
